import React, { useState, useEffect, useMemo } from "react";
import classes from "./addeditrule.module.scss";
import {
  FormControlLabel,
  FormControl,
  TextField,
  Button,
  Grid,
  Box,
  getNativeSelectUtilityClasses,
} from "@mui/material";
import axios from "axios";
import { useSelector } from "react-redux";
import Cookie from "js-cookie";
import { useLocation } from "react-router-dom";
import NotificationView from "../../../../../Shared/Notification/NotificationView";

import { useNavigate, NavLink } from "react-router-dom";
import { constants } from "../../../../../Shared/Url/Constants";
import { CheckIsUserAdmin } from "../../../../../Shared/Utill/Utills";
import SnackBar from "../../../../../Shared/Snackbar/Snackbar";
import DeleteRuleDialog from "../Delete/DeleteRuleDialog";
import { AllControlSearchView } from "../../RuleAssignments/Search/RuleAssignmentsSearch";
import { isEmpty } from "../../../../../Shared/Utill/Utills";
import {
  AddPlusIcon,
  DeleteIcon2,
  DuplicateIcon,
} from "../../../../../Resources/availabilityicon/IconUtils";
import { IconStatus } from "../../../../../Resources/availabilityicon/AvailabilityIcons";
import { Icon, DatePicker, Checkbox } from "@genesis/ui-kit";
import moment from 'moment';
import WorkSchedulesDialog from "../WorkscheduleList/WorkSchedulesDialog";

const AddEditRule = () => {
  const personDetails = useSelector((state) => state.person.personData);
  const urlDetails = useSelector((state) => state.url.urlData);
  const token = Cookie.get("X_TKN");
  const location = useLocation();
  const [isAlertOpen, setAlertOpen] = React.useState({});
  const [eventRAId, setEventRAId] = React.useState(location.state.id);
  console.log("data from search parent!" + JSON.stringify(location.state.id));
  const [flag, setFlag] = React.useState(location.state.flag);
  const [flagTwo,setFlagTwo] = React.useState(location.state.origin)
  const history = useNavigate();
  const { message, severity, open } = isAlertOpen || {};
  const [readOnlyView, setReadyOnly] = React.useState(true);
  const [ongoingActionCompleted, setOngoingActionCompleted] =
    React.useState(true);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [ruleId, setRuleId] = useState("");
  //
  const [effectiveDate, setEffectiveDate] = useState(null);
  //const [preferencesGroup, setPreferencesGroup] = useState("");
  const [displayPreferences, setDisplayPreferences] = useState(false);
  const [latestStartTime, setLatestStartTime] = useState("");
  const [earliestStartTime, setEarliestStartTime] = useState("");
  const [allowSplitShift, setAllowSplicShift] = useState(false);
  const [maxEveningsOff, setMaxEveningsOff] = useState("");
  const [maxWeekendDaysOff, setMaxWeekendDaysOff] = useState("");
  const [minRequiredDaysOff, setMinRequiredDaysOff] = useState("");
  const [maxDaysOff, setMaxDaysOff] = useState("");
  const [maxMorningsOff, setMaxMorningsOff] = useState("");
  const [dayOffOrEveningOffOnly, setDayOffOrEveningOffOnly] = useState(false);
  const [limitEndOfDay, setLimitEndOfDay] = useState(false);
  const [isMorningBefore, setIsMorningBefore] = useState("");
  const [isEveningAfter, setIsEveningAfter] = useState("");
  const [limitTime, setLimitTime] = useState("");

  const [decimalFormatted,setDecimalFormatted] = useState(false);
  const [sunMinHrWarning, setSunMinHrWarning] = useState("");
  const [sunMinHrRequired, setSunMinHrRequired] = useState("");
  const [sunLockDayCheck, setSunLockDayCheck] = useState(false);
  const [sunLockMorningCheck, setSunLockMorningCheck] = useState(false);
  const [sunLockEveningCheck, setSunLockEveningCheck] = useState(false);

  const [monMinHrWarning, setMonMinHrWarning] = useState("");
  const [monMinHrRequired, setMonMinHrRequired] = useState("");
  const [monLockDayCheck, setMonLockDayCheck] = useState(false);
  const [monLockMorningCheck, setMonLockMorningCheck] = useState(false);
  const [monLockEveningCheck, setMonLockEveningCheck] = useState(false);

  const [tueMinHrWarning, setTueMinHrWarning] = useState("");
  const [tueMinHrRequired, setTueMinHrRequired] = useState("");
  const [tueLockDayCheck, setTueLockDayCheck] = useState(false);
  const [tueLockMorningCheck, setTueLockMorningCheck] = useState(false);
  const [tueLockEveningCheck, setTueLockEveningCheck] = useState(false);

  const [wedMinHrWarning, setWedMinHrWarning] = useState("");
  const [wedMinHrRequired, setWedMinHrRequired] = useState("");
  const [wedLockDayCheck, setWedLockDayCheck] = useState(false);
  const [wedLockMorningCheck, setWedLockMorningCheck] = useState(false);
  const [wedLockEveningCheck, setWedLockEveningCheck] = useState(false);

  const [thuMinHrWarning, setThuMinHrWarning] = useState("");
  const [thuMinHrRequired, setThuMinHrRequired] = useState("");
  const [thuLockDayCheck, setThuLockDayCheck] = useState(false);
  const [thuLockMorningCheck, setThuLockMorningCheck] = useState(false);
  const [thuLockEveningCheck, setThuLockEveningCheck] = useState(false);

  const [friMinHrWarning, setFriMinHrWarning] = useState("");
  const [friMinHrRequired, setFriMinHrRequired] = useState("");
  const [friLockDayCheck, setFriLockDayCheck] = useState(false);
  const [friLockMorningCheck, setFriLockMorningCheck] = useState(false);
  const [friLockEveningCheck, setFriLockEveningCheck] = useState(false);

  const [satMinHrWarning, setSatMinHrWarning] = useState("");
  const [satMinHrRequired, setSatMinHrRequired] = useState("");
  const [satLockDayCheck, setSatLockDayCheck] = useState(false);
  const [satLockMorningCheck, setSatLockMorningCheck] = useState(false);
  const [satLockEveningCheck, setSatLockEveningCheck] = useState(false);

  const [showWSDialog, setShowWSDialog] = useState(false);
  const [isCancelEvent, setCancelEvent] = useState(false);
  const [checkedPayload,setCheckedPayload] = useState();

  useEffect(() => {
    //validateDecimals()
    if (flag === "A") {
      makeEditable();
    } else if(flag === "D") {
      // call api to get details
      makeEditable();
      getEventRuleDetails(eventRAId,true);
    } else {
      // call api to get details
      getEventRuleDetails();
    }
  }, []);


 
  const getEventRuleDetails = (id = null, isDuplicate = false) => {
    //  call get rule assignemnt details and assign state
    let earId = id === null ? eventRAId : id;
    let url = `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVL_RULE_GET_BY_RECORD_ID}/${earId}`;

    if(isEmpty(earId)){
      return;
    }
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        console.log(res);
        // Set states for all fields
        setAllStatesAfterGet(res.data,isDuplicate);
      })
      .catch((err) => {
        setAlertOpen({
          open: true,
          severity: "error",
          message: err.response.data.message,
        });
      });
  };

  const cancelEditing = () => {
    //alert(flag)
    if((flagTwo === "Search") && (flag === "D")) {
      // duplicate from search
      //alert("DUP FROM SEARCH")
      //alert("MADE IT IN")
      history("/controls/availabilityapplicationcontrols/rules");
      return; // this return makes it so the method stops going after the history call.
    }
     
    if ((location.state.id !== null) && (location.state.id !== undefined) && (location.state.id !== ""))  {
      // add from edit
      if (flag === "A")
      //alert("this is add from edit")
      getEventRuleDetails(location.state.id);
      setOngoingActionCompleted(true)
      setReadyOnly(true)
      setFlag("E");
      return;
    }

    setCancelEvent(true);
    if (flag === "E") {
      setOngoingActionCompleted(true);
      // call api to reset values
      getEventRuleDetails();
      goToEditMode();
    } else if(flag === "D") {
      setFlag("E");
      setOngoingActionCompleted(true);
      // call api to reset values
      goToEditMode();
      getEventRuleDetails(eventRAId,false);
    } else {
      history("/controls/availabilityapplicationcontrols/rules");
    }
  };

  const makeEditable = () => {
    setOngoingActionCompleted(false);
    console.log(readOnlyView + " ready only ");
    if (readOnlyView == true) {
      setReadyOnly(false);
    }
  };
  const makeReadOnly = () => {
    //on click of save
    setOngoingActionCompleted(true);
    if (readOnlyView == false) {
      setReadyOnly(true);
    }
  };

  const handleAlertNotifClose = () => {
    setAlertOpen({});
  };

  const saveData = () => {
    //: validation for fields
    if (!ValidateAddEdit()) {
      return;
    }

    if (flag === "A") {
      // save data and call add api
      addRuleAPICall();
    } else if (flag == "E") {
      // call edit rule  API
      editRuleAPI();
    } else if (flag == "D") {
      //TODO:call duplicate api
      // call add rule  API
      addRuleAPICall();
    }
  };

  const onCloseDialog = () => {
    setOpenDeleteDialog(false);
  };

  const onDeleteCallback = (responseType, message) => {
    onCloseDialog();
    //handle success / failue
    setAlertOpen({
      open: true,
      severity: responseType,
      message: message,
    });
    // refresh data
    if (responseType == "success") {
      // navigate back to rule search page
      history("/controls/availabilityapplicationcontrols/rules", {
        state: { message: message, isDelete: true },
      });
    }
  };

  const addRulesBtnClick = () => {
    setFlag("A");
    makeEditable();
    let arID;
    if (eventRAId !== undefined || null) {
      arID = eventRAId;
      emptyAllStates();
      history("/controls/availabilityapplicationcontrols/rules/Add", {
        state: {id: arID, flag: "A"},
      });
    } else {
      emptyAllStates();
    history("/controls/availabilityapplicationcontrols/rules/Add", {
      state: {id: "", flag: "A"},
    });
    }
    
  };

 const setAllStatesAfterGet = (data,isDuplicate) => {

  setEventRAId(data.arId);
  setRuleId(data.ruleId);
  setEffectiveDate(isDuplicate ? null : data.effectiveDate);
  setDisplayPreferences(data.preferences_visible.toLowerCase() == 'y' ? true : false);
  setLatestStartTime(data.startselect_stops_at);
  setEarliestStartTime(data.endselect_starts_at);
  setAllowSplicShift(data.allow_splitshifts.toLowerCase() == "y" ? true : false);
  setMaxEveningsOff(data.nbrdays_max_pm_off);
  setMaxWeekendDaysOff(data.nbrdays_max_wkend_off);
  setMinRequiredDaysOff(data.nbrdays_min_days_off);
  setMaxDaysOff(data.nbrdays_max_off);
  setMaxMorningsOff(data.nbrdays_max_am_off);
  setDayOffOrEveningOffOnly(data.day_off_pm_restrict.toLowerCase() == 'y' ? true : false);
  setLimitEndOfDay(data.end_my_day_is_active.toLowerCase() == 'y' ? true : false);
  setIsMorningBefore(data.counts_as_am_before);
  setIsEveningAfter(data.counts_as_pm_after);
  setLimitTime(data.end_my_day_at_time);

  setSunMinHrWarning(data.sun_min_shift_hrs_warn);
  setSunMinHrRequired(data.sun_min_shift_hrs_req);
  setSunLockDayCheck(data.sun_editable.toLowerCase() == 'y' ? false : true);
  setSunLockMorningCheck(data.sun_start_editable.toLowerCase() == 'y' ? false : true);
  setSunLockEveningCheck(data.sun_end_editable.toLowerCase() == 'y' ? false : true);

  setMonMinHrWarning(data.mon_min_shift_hrs_warn);
  setMonMinHrRequired(data.mon_min_shift_hrs_req);
  setMonLockDayCheck(data.mon_editable.toLowerCase() == 'y' ? false : true);
  setMonLockMorningCheck(data.mon_start_editable.toLowerCase() == 'y' ? false : true);
  setMonLockEveningCheck(data.mon_end_editable.toLowerCase() == 'y' ? false : true);

  setTueMinHrWarning(data.tue_min_shift_hrs_warn);
  setTueMinHrRequired(data.tue_min_shift_hrs_req);
  setTueLockDayCheck(data.tue_editable.toLowerCase() == 'y' ? false : true);
  setTueLockMorningCheck(data.tue_start_editable.toLowerCase() == 'y' ? false : true);
  setTueLockEveningCheck(data.tue_end_editable.toLowerCase() == 'y' ? false : true);

  setWedMinHrWarning(data.wed_min_shift_hrs_warn);
  setWedMinHrRequired(data.wed_min_shift_hrs_req);
  setWedLockDayCheck(data.wed_editable.toLowerCase() == 'y' ? false : true);
  setWedLockMorningCheck(data.wed_start_editable.toLowerCase() == 'y' ? false : true);
  setWedLockEveningCheck(data.wed_end_editable.toLowerCase() == 'y' ? false : true);

  setThuMinHrWarning(data.thu_min_shift_hrs_warn);
  setThuMinHrRequired(data.thu_min_shift_hrs_req);
  setThuLockDayCheck(data.thu_editable.toLowerCase() == 'y' ? false : true);
  setThuLockMorningCheck(data.thu_start_editable.toLowerCase() == 'y' ? false : true);
  setThuLockEveningCheck(data.thu_end_editable.toLowerCase() == 'y' ? false : true);

  setFriMinHrWarning(data.fri_min_shift_hrs_warn);
  setFriMinHrRequired(data.fri_min_shift_hrs_req);
  setFriLockDayCheck(data.fri_editable.toLowerCase() == 'y' ? false : true);
  setFriLockMorningCheck(data.fri_start_editable.toLowerCase() == 'y' ? false : true);
  setFriLockEveningCheck(data.fri_end_editable.toLowerCase() == 'y' ? false : true);

  setSatMinHrWarning(data.sat_min_shift_hrs_warn);
  setSatMinHrRequired(data.sat_min_shift_hrs_req);
  setSatLockDayCheck(data.sat_editable.toLowerCase() == 'y' ? false : true);
  setSatLockMorningCheck(data.sat_start_editable.toLowerCase() == 'y' ? false : true);
  setSatLockEveningCheck(data.sat_end_editable.toLowerCase() == 'y' ? false : true);

 }

const emptyAllStates = () => {
    setRuleId("");
    setEffectiveDate(null);
    setDisplayPreferences(false);
    setLatestStartTime("");
    setEarliestStartTime("");
    setAllowSplicShift(false);
    setMaxEveningsOff("");
    setMaxWeekendDaysOff("");
    setMinRequiredDaysOff("");
    setMaxDaysOff("");
    setMaxMorningsOff("");
    setDayOffOrEveningOffOnly(false);
    setLimitEndOfDay(false);
    setIsMorningBefore("");
    setIsEveningAfter("");
    setLimitTime("");

    setSunMinHrWarning("");
    setSunMinHrRequired("");
    setSunLockDayCheck(false);
    setSunLockMorningCheck(false);
    setSunLockEveningCheck(false);

    setMonMinHrWarning("");
    setMonMinHrRequired("");
    setMonLockDayCheck(false);
    setMonLockMorningCheck(false);
    setMonLockEveningCheck(false);

    setTueMinHrWarning("");
    setTueMinHrRequired("");
    setTueLockDayCheck(false);
    setTueLockMorningCheck(false);
    setTueLockEveningCheck(false);

    setWedMinHrWarning("");
    setWedMinHrRequired("");
    setWedLockDayCheck(false);
    setWedLockMorningCheck(false);
    setWedLockEveningCheck(false);

    setThuMinHrWarning("");
    setThuMinHrRequired("");
    setThuLockDayCheck(false);
    setThuLockMorningCheck(false);
    setThuLockEveningCheck(false);

    setFriMinHrWarning("");
    setFriMinHrRequired("");
    setFriLockDayCheck(false);
    setFriLockMorningCheck(false);
    setFriLockEveningCheck(false);

    setSatMinHrWarning("");
    setSatMinHrRequired("");
    setSatLockDayCheck(false);
    setSatLockMorningCheck(false);
    setSatLockEveningCheck(false);

  }
 
  const onDeleteAction = () => {
    setOpenDeleteDialog(true);
  };

  const onDuplicateAction = () => {
    //TODO: reload page with duplicate feature
    // make effective date blank
    setFlag("D");
    makeEditable();
    // empty effective date state
    getEventRuleDetails(eventRAId,true);
   // setEffectiveDate(null);
    history("/controls/availabilityapplicationcontrols/rules/Duplicate", {
      state: {id: eventRAId, flag: "D"},
    });
  };

  const goToEditMode = () => {
    setFlag("E");
    makeReadOnly();
    history("/controls/availabilityapplicationcontrols/rules/Edit", {state: {id: eventRAId, flag: "E"}});
  };

  const ValidateAddEdit = () => {
    let isDataValid = true;
    if (isEmpty(ruleId)) {
      isDataValid = false;
      setAlertOpen({
        open: true,
        severity: "error",
        message: "Please type Rule ID",
      });
      return isDataValid;
    }
    else if (isNaN(ruleId)) {
      isDataValid = false;
      showErrorMsg("Rule ID should be Numeric.");
    }
    else if(!isEmpty(effectiveDate) && moment(effectiveDate).format('YYYY-MM-DD') == "Invalid date"   ){
      isDataValid = false;
      showErrorMsg("Please enter valid Effective Date in (mmm dd, yyyy) format." );
    }
    else if(!isEmpty(maxDaysOff) && isNaN(maxDaysOff)) {
      isDataValid = false;
      showErrorMsg("Max Days Off should be Numeric.");
    }
    else if(!isEmpty(maxMorningsOff) && isNaN(maxMorningsOff)) {
      isDataValid = false;
      showErrorMsg("Max Mornings Off should be Numeric.");
    }
    else if(!isEmpty(maxEveningsOff) && isNaN(maxEveningsOff)) {
      isDataValid = false;
      showErrorMsg("Max Evenings Off should be Numeric.");
    }
    else if(!isEmpty(maxWeekendDaysOff) && isNaN(maxWeekendDaysOff)) {
      isDataValid = false;
      showErrorMsg("Max Weekend Days Off should be Numeric.");
    }
    else if(!isEmpty(minRequiredDaysOff) && isNaN(minRequiredDaysOff)) {
      isDataValid = false;
      showErrorMsg("Min Required Days Off should be Numeric.");
    }
    return isDataValid;
  };

  const showErrorMsg = (msg) => {
    setAlertOpen({
      open: true,
      severity: "error",
      message: msg,
    });
  }

  const prepareRulePayload = (mode) => {
    let data = {
      ruleId : ruleId,
      effectiveDate : !isEmpty(effectiveDate) ? moment(effectiveDate).format('YYYY-MM-DD') : null,
      pwhgrpnbr : ruleId,
      preferences_editable : "y",
      preferences_visible : displayPreferences == true ? "y" : "n",
      startselect_stops_at : latestStartTime,
      endselect_starts_at : earliestStartTime,
      allow_splitshifts : allowSplitShift == true ? "y" : "n",
      nbrdays_max_off : maxDaysOff,
      nbrdays_max_am_off : maxMorningsOff,
      nbrdays_max_pm_off : maxEveningsOff,
      nbrdays_max_wkend_off : maxWeekendDaysOff,
      nbrdays_min_days_off : minRequiredDaysOff,
      counts_as_am_before : isMorningBefore,
      counts_as_pm_after : isEveningAfter,
      end_my_day_is_active : limitEndOfDay == true ? "y" : "n",
      end_my_day_at_time : limitEndOfDay == true ? limitTime : null,
      day_off_pm_restrict : dayOffOrEveningOffOnly == true ? "y" : "n",
      sun_editable : sunLockDayCheck == true ? "n" : "y",
      sun_start_editable : sunLockMorningCheck == true ? "n" : "y",
      sun_end_editable : sunLockEveningCheck == true ? "n" : "y",
      sun_min_shift_hrs_req : validateDecimals(sunMinHrRequired) ,
      sun_min_shift_hrs_warn : validateDecimals(sunMinHrWarning),
      mon_editable : monLockDayCheck == true ? "n" : "y",
      mon_start_editable : monLockMorningCheck == true ? "n" : "y",
      mon_end_editable : monLockEveningCheck == true ? "n" : "y",
      mon_min_shift_hrs_req : validateDecimals(monMinHrRequired),
      mon_min_shift_hrs_warn : validateDecimals(monMinHrWarning),
      tue_editable : tueLockDayCheck == true ? "n" : "y",
      tue_start_editable : tueLockMorningCheck == true ? "n" : "y",
      tue_end_editable : tueLockEveningCheck == true ? "n" : "y",
      tue_min_shift_hrs_req :validateDecimals(tueMinHrRequired),
      tue_min_shift_hrs_warn : validateDecimals(tueMinHrWarning),
      wed_editable : wedLockDayCheck == true ? "n" : "y",
      wed_start_editable : wedLockMorningCheck == true ? "n" : "y",
      wed_end_editable : wedLockEveningCheck == true ? "n" : "y",
      wed_min_shift_hrs_req : validateDecimals(wedMinHrRequired),
      wed_min_shift_hrs_warn : validateDecimals(wedMinHrWarning),
      thu_editable : thuLockDayCheck == true ? "n" : "y",
      thu_start_editable : thuLockMorningCheck == true ? "n" : "y",
      thu_end_editable : thuLockEveningCheck == true ? "n" : "y",
      thu_min_shift_hrs_req : validateDecimals(thuMinHrRequired),
      thu_min_shift_hrs_warn : validateDecimals(thuMinHrWarning),
      fri_editable : friLockDayCheck == true ? "n" : "y",
      fri_start_editable : friLockMorningCheck == true ? "n" : "y",
      fri_end_editable : friLockEveningCheck == true ? "n" : "y",
      fri_min_shift_hrs_req : validateDecimals(friMinHrRequired),
      fri_min_shift_hrs_warn : validateDecimals(friMinHrWarning),
      sat_editable : satLockDayCheck == true ? "n" : "y",
      sat_start_editable : satLockMorningCheck == true ? "n" : "y",
      sat_end_editable : satLockEveningCheck == true ? "n" : "y",
      sat_min_shift_hrs_req : validateDecimals(satMinHrRequired),
      sat_min_shift_hrs_warn : validateDecimals(satMinHrWarning),
      createDate : "",
      lastUpdatedBy : personDetails.emplID,
      lastUpdate : ""
  };
    return data;
  }

  const checkPayload = (payload) => {
    //console.log("something is fishy" + JSON.stringify(payload))
    let payloadIsGood = true;
    if (payload.sun_min_shift_hrs_req === false || payload.sun_min_shift_hrs_warn === false) {
      payloadIsGood = false;
      if (payload.sun_min_shift_hrs_req === false) {
        setSunMinHrRequired("")
      }

      if (payload.sun_min_shift_hrs_warn === false) {
        setSunMinHrWarning("")
      }
    }

    if (payload.mon_min_shift_hrs_req === false || payload.mon_min_shift_hrs_warn === false) {
      payloadIsGood = false;
      if (payload.mon_min_shift_hrs_req === false) {
        setMonMinHrRequired("")
      }

      if (payload.mon_min_shift_hrs_warn === false) {
        setMonMinHrWarning("")
      }
    }

    if (payload.tue_min_shift_hrs_req === false || payload.tue_min_shift_hrs_warn === false) {
      payloadIsGood = false;
      if (payload.tue_min_shift_hrs_req === false) {
        setTueMinHrRequired("")
      }

      if (payload.tue_min_shift_hrs_warn === false) {
        setTueMinHrWarning("")
      }
    }

    if (payload.wed_min_shift_hrs_req === false || payload.wed_min_shift_hrs_warn === false) {
      payloadIsGood = false;
      if (payload.wed_min_shift_hrs_req === false) {
        setWedMinHrRequired("")
      }

      if (payload.wed_min_shift_hrs_warn === false) {
        setWedMinHrWarning("")
      }
    }

    if (payload.thu_min_shift_hrs_req === false || payload.thu_min_shift_hrs_warn === false) {
      payloadIsGood = false;
      if (payload.thu_min_shift_hrs_req === false) {
        setThuMinHrRequired("")
      }

      if (payload.thu_min_shift_hrs_warn === false) {
        setThuMinHrWarning("")
      }
    }
    
    if (payload.fri_min_shift_hrs_req === false || payload.fri_min_shift_hrs_warn === false) {
      payloadIsGood = false;
      if (payload.fri_min_shift_hrs_req === false) {
        setFriMinHrRequired("")
      }

      if (payload.fri_min_shift_hrs_warn === false) {
        setFriMinHrWarning("")
      }
    }

    if (payload.sat_min_shift_hrs_req === false || payload.sat_min_shift_hrs_warn === false) {
      payloadIsGood = false;
      if (payload.sat_min_shift_hrs_req === false) {
        setSatMinHrRequired("")
      }

      if (payload.sat_min_shift_hrs_warn === false) {
        setSatMinHrWarning("")
      }
    }

    if (payloadIsGood) {
      setCheckedPayload(payload)
    } else {
      //setSunMinHrWarning("")
    }
    return payloadIsGood;
  } // checkPayload

  const addRuleAPICall = () => {
   
    let data = prepareRulePayload(flag);
    if (checkPayload(data)) {
      axios
      .post(
        `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVL_RULE_ADD}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        let message = (flag == "D") ? "Rule saved successfully" : `Rule - ${ruleId} added successfully`;
        setAlertOpen({
          open: true,
          severity: "success",
          message: message,
        });
        // set all states
        makeReadOnly();
        setFlag("E");
        // get rules details after add success
        setEventRAId(res.data.arId);
        getEventRuleDetails(res.data.arId,false);
        goToEditMode();

      })
      .catch((err) => {
        let message = err.response.data.message;
        if(message == "Duplicate record not allowed."){
          message = (flag == "D") ? "You have a duplicate record! please change Rule ID or Effective Date": "RuleID & Effective Date combination already exists.";
        }
        setAlertOpen({
          open: true,
          severity: "error",
          message: message,
        });
      });
    } // if formatted
    else {
      setAlertOpen({
        open: true,
        severity: "error",
        message: "Please enter either .25 .50 or .75 for partial hours! 24 hour maximum.",
      });
      //setAlertOpen({})
    }
    
  };

  
  const editRuleAPI = () => {
    let data = prepareRulePayload(flag);

    if (checkPayload(data)) {
      axios
      .put(
        `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVL_RULE_UPDATE_BY_RECORD_ID}/${eventRAId}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        setAlertOpen({
          open: true,
          severity: "success",
          message: `Rule - ${ruleId} edited successfully`,
        });
        makeReadOnly();
        //  get rules details after update success
        getEventRuleDetails(eventRAId,false);
      })
      .catch((err) => {
        let message = err.response.data.message;
        if(message == "Duplicate record not allowed."){
          message = "RuleID & Effective Date combination already exists.";
        }
        setAlertOpen({
          open: true,
          severity: "error",
          message: message,
        });
      });
    } // if decimal formatted 
      else {
        setAlertOpen({
          open: true,
          severity: "error",
          message: "Please enter either .25 .50 or .75 for partial hours! 24 hour maximum.",
        });
        //setAlertOpen({})
      }

    
  };

  const changeDisplayPreferences = (e) => {
    setDisplayPreferences(e.target.checked);
  };

  function enableSundayOnly(date) {
    return date.getDay() !== 0 ;
  }
  const wsLinkClickAction = () => {
    if(!isEmpty(ruleId)){
      setShowWSDialog(true)
    }else{
      setAlertOpen({
        open: true,
        severity: "error",
        message: "Please enter Rule ID to check the tagged WorkSchedules",
      });
    }
  }
  const validateDecimals = (input) => {
    //setDecimalFormatted(true)
    let testInput = String(input)
    //alert(testInput)
    let splitInput;
    //alert("oh boy " + testInput.length)
    if ((testInput.length > 1) && testInput.includes(".")) {
      splitInput = testInput.split(".")
    } 
    let decimalCondition;
   // if (splitInput[0].length > 2) {}

    if ((testInput.length >= 1) && (!testInput.includes(".")) ) {
      if (testInput.length > 2 || parseInt(testInput) > 24) {
        //setDecimalFormatted(false)
        
        setAlertOpen({
          open: true,
          severity: "error",
          message: "Please enter no more than 24 hours! " + input,
        }) ;
        return false;
      } else {
        
        return testInput;
      } // normal number between 0 and 24
    } else {
      //alert("this is test input " + testInput + "this is the split input " + splitInput)
      // check for decimals of proper format
      if (splitInput !== undefined) {
        //alert(parseInt(splitInput[1]))
        //alert("vaues are equal to expected " + ((parseInt(splitInput[1]) === 0) || (parseInt(splitInput[1]) === 25) || (parseInt(splitInput[1]) === 50) || (parseInt(splitInput[1]) === 5) || (parseInt(splitInput[1]) === 75 )) )
        decimalCondition = ((parseInt(splitInput[1]) === 0) || (parseInt(splitInput[1]) === 25) || (parseInt(splitInput[1]) === 50) || (parseInt(splitInput[1]) === 5) || (parseInt(splitInput[1]) === 75 ) === true ? true : false) 
        //alert("if condition is true, we have valid decimals, if not, we have invalid, and should throw error " + decimalCondition)
      }
       
      }
      if (splitInput !== undefined) {
        //alert("MADE IT BEFORE 24 HR CHECK")
      if ((splitInput[0]!== undefined) && splitInput[0].length > 2 || (parseInt(splitInput[0]) > 24) || (splitInput[1] > 0) &&  (parseInt(splitInput[0]) >= 24) ) {
        //setDecimalFormatted(false)
        setAlertOpen({
          open: true,
          severity: "error",
          message: "Please enter no more than 24 hours! " + input,
        });
        return false;
      } 
      else {
        if ((splitInput[1] !== undefined) && splitInput[1].length === 1 )  {
          if (parseFloat(splitInput[1]) !== 5) {
            //setDecimalFormatted(false)
            setAlertOpen({
              open: true,
              severity: "error",
              message: "Please enter either .25, .50, or .75 for partial hours! " + input,
            });
            return false;
          } //x.5 is ok
          else {
            //setDecimalFormatted(true)
            return testInput

          }
        } 
    //alert("DO WE Even MAKE IT HERE " + splitInput + "and is the decimal condition false or true? " + decimalCondition)
    if ((splitInput[1] !== undefined) && splitInput[1].length > 2) {
      
      setAlertOpen({
        open: true,
        severity: "error",
        message: "Please enter no more than 2 decimal places! " + input,
      });
      return false;
    } 
    else {

      if ((splitInput[1] !== undefined) && splitInput[1].length === 2) {
        if (!decimalCondition) {
          //setDecimalFormatted(false)
          setAlertOpen({
            open: true,
            severity: "error",
            message: "Please enter either .25 .50 or .75 for partial hours! " + input,
          });
          return false;
        } 
        else {
          //setDecimalFormatted(true)
          return testInput;
        }
      }

    }
    }
  } // splitinput undefined condition
   
  } // validate Decimals function 

  function testSet(val) {
    //alert(val  +" has changed!")
    setSunMinHrWarning(val)
  } 

  return (
    <div className={classes.pagemargin}>
      <AllControlSearchView />
      <div style={{ width: "100%" }}>
        <div
          className={classes.eventpagetitle}
          style={{ textAlign: "left", width: "40%" }}
        >
          {flag == "A" ? "Add" : "Rule - " + ruleId}
        </div>
        <div className={classes.icon_box}>
          <div
            className={classes.icon_text}
            onClick={
              ongoingActionCompleted ? addRulesBtnClick : undefined
            }
          >
            <AddPlusIcon
              type={
                ongoingActionCompleted ? IconStatus.NORMAL : IconStatus.DISABLED
              }
            />
            <div
              className={classes.icon_text}
              style={{
                color: ongoingActionCompleted ? "inherit" : "grey",
                display: "inline-block",
                marginLeft: "5px",
                cursor:"pointer",
                textDecoration:"underline"
              }}
            >
              <u> Add </u>
            </div>
          </div>
          <div
            className={classes.icon_text}
            onClick={() => !ongoingActionCompleted? null: onDuplicateAction()}
          >
            <DuplicateIcon
              type={!ongoingActionCompleted ? IconStatus.DISABLED : IconStatus.NORMAL}
            />
            <div
              className={classes.icon_text}
              style={{
                color: !ongoingActionCompleted ? "grey" : "inherit",
                marginLeft: "5px",
                cursor:"pointer",
                textDecoration:"underline"
              }}
            >
              <u>Duplicate</u>
            </div>
          </div>

          <div
            className={!ongoingActionCompleted || ruleId === 999 ? classes.icon_text2: classes.icon_text}
            onClick={() => !ongoingActionCompleted || ruleId === 999 ? null : onDeleteAction()}
          >
            <DeleteIcon2
              cursor = {!ongoingActionCompleted || ruleId === 999 ? true : false}
              type={!ongoingActionCompleted || ruleId === 999 ? IconStatus.DISABLED : IconStatus.NORMAL}
            />
            <div
              className={classes.icon_text}
              style={{
                color: !ongoingActionCompleted || ruleId === 999 ? "grey": "inherit",
                marginLeft: "5px",
                cursor:ruleId === 999 ? 'default' : "pointer",
                textDecoration:"underline"
              }}
            >
              <u>Delete</u>
            </div>
          </div>
        </div>
      </div>
      {readOnlyView && (
        <NotificationView
          message={"'Read-only' view, click on 'Edit' to edit event details."}
          severity="info"
        />
      )}
      <div className={classes.eventiconmargin}>
        <div className={classes.pagesubtitle}> </div>
        {/*   code goes here */}

        <div>
          <div className={classes.eventpagemargin}>
            <Grid container spacing={4} rowSpacing={3}>
              <Grid key={0} item xs={2}>
                <div className={classes.pagesubtitle}> Rule Details </div>
              </Grid>
              <Grid key={1} item xs={2}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Rule ID*"
                    onChange={(e) => setRuleId(e.target.value)}
                    value={ruleId}
                    inputProps={{ readOnly: readOnlyView || flag == "E" }}
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2}>
                <FormControl error={false} style={{ minWidth: "100%" }}>
                  <DatePicker
                    label="Effective Date*"
                    renderInput={(params) => <TextField {...params} />}
                    inputFormat="MMM dd, yyyy"
                    value={effectiveDate}
                    error={false}
                    onError={null}
                    onChange={(newValue) => {
                      setEffectiveDate(newValue);
                    }}
                    readOnly={readOnlyView}
                    showDaysOutsideCurrentMonth
                    shouldDisableDate={enableSundayOnly}
                    minDate={new Date()} 
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Preferences Group*"
                    value={ruleId || ''}
                    inputProps={{ readOnly: true }}
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={1}>
                <div className={classes.label_text}>
                <a onClick={() => wsLinkClickAction()} style={{cursor: 'pointer', textDecoration: "underline" }}>Work Schedule</a>
                                            </div>
              </Grid>
              <Grid key={1} item xs={2}></Grid>

              <Grid key={2} item xs={2}></Grid>
              <Grid key={3} item xs={2}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={changeDisplayPreferences}
                    control={
                      <Checkbox
                        checked={displayPreferences}
                        disabled={readOnlyView}
                      />
                    }
                    label="Display Preferences"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={8} />

              <Grid key={0} item xs={2} marginTop={3}>
                <div className={classes.pagesubtitle}>Shifts</div>
              </Grid>
              <Grid key={0} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    type="time"
                    label="Latest Start Time"
                    inputProps={{ readOnly: readOnlyView }}
                    value={latestStartTime}
                    onChange={(e) => setLatestStartTime(e.target.value)}
                  />
                </FormControl>
              </Grid>
              <Grid key={0} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    type="time"
                    inputProps={{ readOnly: readOnlyView }}
                    label="Earliest End Time"
                    value={earliestStartTime}
                    onChange={(e) => setEarliestStartTime(e.target.value)}
                  />
                </FormControl>
              </Grid>
              <Grid key={0} item xs={6} marginTop={3}></Grid>
              <Grid key={0} item xs={2} marginTop={3}></Grid>
              <Grid key={3} item xs={2}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setAllowSplicShift(e.target.checked)}
                    control={
                      <Checkbox
                        checked={allowSplitShift}
                        disabled={readOnlyView}
                      />
                    }
                    label="Allow Split Shifts"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={8} />

              <Grid key={0} item xs={2} marginTop={3}>
                <div className={classes.pagesubtitle}>Day Off</div>
              </Grid>
              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Max Days Off*"
                    onChange={(e) => setMaxDaysOff(e.target.value)}
                    value={maxDaysOff}
                    inputProps={{ readOnly: readOnlyView }}
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Max Mornings Off*"
                    onChange={(e) => setMaxMorningsOff(e.target.value)}
                    value={maxMorningsOff}
                    inputProps={{ readOnly: readOnlyView }}
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Max Evenings Off*"
                    onChange={(e) => setMaxEveningsOff(e.target.value)}
                    value={maxEveningsOff}
                    inputProps={{ readOnly: readOnlyView }}
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Max Weekend Days Off*"
                    onChange={(e) => setMaxWeekendDaysOff(e.target.value)}
                    value={maxWeekendDaysOff}
                    inputProps={{ readOnly: readOnlyView }}
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Min Required Days Off*"
                    onChange={(e) => setMinRequiredDaysOff(e.target.value)}
                    value={minRequiredDaysOff}
                    inputProps={{ readOnly: readOnlyView }}
                  />
                </FormControl>
              </Grid>

              <Grid key={0} item xs={2} marginTop={3}>
                <div className={classes.pagesubtitle}>Time</div>
              </Grid>
              <Grid key={0} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    type="time"
                    inputProps={{ readOnly: readOnlyView }}
                    label="Is Morning Before*"
                    value={isMorningBefore}
                    onChange={(e) => setIsMorningBefore(e.target.value)}
                  />
                </FormControl>
              </Grid>
              <Grid key={0} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    type="time"
                    inputProps={{ readOnly: readOnlyView }}
                    label="Is Evening After*"
                    value={isEveningAfter}
                    onChange={(e) => setIsEveningAfter(e.target.value)}
                  />
                </FormControl>
              </Grid>
              <Grid key={0} item xs={6} marginTop={3}></Grid>
              <Grid key={0} item xs={2}></Grid>
              <Grid key={3} item xs={2.3}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) =>
                      setDayOffOrEveningOffOnly(e.target.checked)
                    }
                    control={
                      <Checkbox
                        checked={dayOffOrEveningOffOnly}
                        disabled={readOnlyView}
                      />
                    }
                    label="Day Off Only or Evenings Off Only"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.7}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setLimitEndOfDay(e.target.checked)}
                    control={
                      <Checkbox
                        checked={limitEndOfDay}
                        disabled={readOnlyView}
                      />
                    }
                    label="Limit End Of Day"
                  />
                </FormControl>
              </Grid>
              <>
                {limitEndOfDay == true ? (
                  <>
                    <Grid key={0} item xs={2}>
                      <FormControl style={{ minWidth: "100%" }}>
                        <TextField
                          type="time"
                          inputProps={{ readOnly: readOnlyView }}
                          sx={{ minWidth: "100%" }}
                          label="Set Limit*"
                          value={limitTime || ""}
                          onChange={(e) => setLimitTime(e.target.value)}
                        />
                      </FormControl>
                    </Grid>
                    <Grid key={3} item xs={4} />
                  </>
                ) : (
                  <Grid key={3} item xs={6} />
                )}
              </>
              <Grid key={0} item xs={2} marginTop={3}>
                <div className={classes.pagesubtitle}>Day Controls</div>
              </Grid>

              <Grid key={0} item xs={1} marginTop={4}>
                <div className={classes.label_text}>Sunday</div>
              </Grid>

              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Min Hours Warning*"
                    onChange={(e) => testSet(e.target.value)}
                    value={sunMinHrWarning}
                    inputProps={{ readOnly: readOnlyView }}
                    type="number"
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={3}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Min Hours Required*"
                    onChange={(e) => setSunMinHrRequired(e.target.value)}
                    value={sunMinHrRequired}
                    inputProps={{ readOnly: readOnlyView }}
                    type="number"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={3}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setSunLockDayCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={sunLockDayCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Day"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={3}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setSunLockMorningCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={sunLockMorningCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Morning"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={3}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setSunLockEveningCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={sunLockEveningCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Evening"
                  />
                </FormControl>
              </Grid>
              {/* Monday */}
              <Grid key={0} item xs={2} marginTop={1} />
              <Grid key={0} item xs={1} marginTop={2}>
                <div className={classes.label_text}>Monday</div>
              </Grid>

              <Grid key={1} item xs={2} marginTop={1}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Min Hours Warning*"
                    onChange={(e) => setMonMinHrWarning(e.target.value)}
                    value={monMinHrWarning}
                    inputProps={{ readOnly: readOnlyView }}
                    type="number"
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={1}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Min Hours Required*"
                    onChange={(e) => setMonMinHrRequired(e.target.value)}
                    value={monMinHrRequired}
                    inputProps={{ readOnly: readOnlyView }}
                    type="number"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={1}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setMonLockDayCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={monLockDayCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Day"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={1}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setMonLockMorningCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={monLockMorningCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Morning"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={1}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setMonLockEveningCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={monLockEveningCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Evening"
                  />
                </FormControl>
              </Grid>

              {/* Tuesday */}
              <Grid key={0} item xs={2} marginTop={1} />
              <Grid key={0} item xs={1} marginTop={2}>
                <div className={classes.label_text}>Tuesday</div>
              </Grid>

              <Grid key={1} item xs={2} marginTop={1}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Min Hours Warning*"
                    onChange={(e) => setTueMinHrWarning(e.target.value)}
                    value={tueMinHrWarning}
                    inputProps={{ readOnly: readOnlyView }}
                    type="number"
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={1}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Min Hours Required*"
                    onChange={(e) => setTueMinHrRequired(e.target.value)}
                    value={tueMinHrRequired}
                    inputProps={{ readOnly: readOnlyView }}
                    type="number"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={1}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setTueLockDayCheck(e.target.value)}
                    control={
                      <Checkbox
                        checked={tueLockDayCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Day"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={1}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setTueLockMorningCheck(e.target.value)}
                    control={
                      <Checkbox
                        checked={tueLockMorningCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Morning"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={1}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setTueLockEveningCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={tueLockEveningCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Evening"
                  />
                </FormControl>
              </Grid>

              {/* Wednesday */}
              <Grid key={0} item xs={2} marginTop={1} />
              <Grid key={0} item xs={1} marginTop={2}>
                <div className={classes.label_text}>Wednesday</div>
              </Grid>

              <Grid key={1} item xs={2} marginTop={1}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Min Hours Warning*"
                    onChange={(e) => setWedMinHrWarning(e.target.value)}
                    value={wedMinHrWarning}
                    inputProps={{ readOnly: readOnlyView }}
                    type="number"
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={1}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Min Hours Required*"
                    onChange={(e) => setWedMinHrRequired(e.target.value)}
                    value={wedMinHrRequired}
                    inputProps={{ readOnly: readOnlyView }}
                    type="number"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={1}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setWedLockDayCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={wedLockDayCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Day"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={1}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setWedLockMorningCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={wedLockMorningCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Morning"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={1}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setWedLockEveningCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={wedLockEveningCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Evening"
                  />
                </FormControl>
              </Grid>

              {/* Thursday */}
              <Grid key={0} item xs={2} marginTop={1} />
              <Grid key={0} item xs={1} marginTop={2}>
                <div className={classes.label_text}>Thursday</div>
              </Grid>

              <Grid key={1} item xs={2} marginTop={1}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Min Hours Warning*"
                    onChange={(e) => setThuMinHrWarning(e.target.value)}
                    value={thuMinHrWarning}
                    inputProps={{ readOnly: readOnlyView }}
                    type="number"
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={1}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Min Hours Required*"
                    onChange={(e) => setThuMinHrRequired(e.target.value)}
                    value={thuMinHrRequired}
                    inputProps={{ readOnly: readOnlyView }}
                    type="number"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={1}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setThuLockDayCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={thuLockDayCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Day"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={1}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setThuLockMorningCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={thuLockMorningCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Morning"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={1}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setThuLockEveningCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={thuLockEveningCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Evening"
                  />
                </FormControl>
              </Grid>

              {/* Friday */}
              <Grid key={0} item xs={2} marginTop={1} />
              <Grid key={0} item xs={1} marginTop={2}>
                <div className={classes.label_text}>Friday</div>
              </Grid>

              <Grid key={1} item xs={2} marginTop={1}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Min Hours Warning*"
                    onChange={(e) => setFriMinHrWarning(e.target.value)}
                    value={friMinHrWarning}
                    inputProps={{ readOnly: readOnlyView }}
                    type="number"
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={1}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Min Hours Required*"
                    onChange={(e) => setFriMinHrRequired(e.target.value)}
                    value={friMinHrRequired}
                    inputProps={{ readOnly: readOnlyView }}
                    type="number"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={1}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setFriLockDayCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={friLockDayCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Day"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={1}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setFriLockMorningCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={friLockMorningCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Morning"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={1}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setFriLockEveningCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={friLockEveningCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Evening"
                  />
                </FormControl>
              </Grid>

              {/* Saturday */}
              <Grid key={0} item xs={2} marginTop={1} />
              <Grid key={0} item xs={1} marginTop={2}>
                <div className={classes.label_text}>Saturday</div>
              </Grid>

              <Grid key={1} item xs={2} marginTop={1}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Min Hours Warning*"
                    onChange={(e) => setSatMinHrWarning(e.target.value)}
                    value={satMinHrWarning}
                    inputProps={{ readOnly: readOnlyView,min:0 }}
                    type="number"
                  />
                </FormControl>
              </Grid>
              <Grid key={1} item xs={2} marginTop={1}>
                <FormControl style={{ minWidth: "100%" }}>
                  <TextField
                    label="Min Hours Required*"
                    onChange={(e) => setSatMinHrRequired(e.target.value)}
                    value={satMinHrRequired}
                    inputProps={{ readOnly: readOnlyView }}
                    type="number"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={1}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setSatLockDayCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={satLockDayCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Day"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={1}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setSatLockMorningCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={satLockMorningCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Morning"
                  />
                </FormControl>
              </Grid>
              <Grid key={3} item xs={1.4} marginTop={1}>
                <FormControl>
                  <FormControlLabel
                    inputProps={{ readOnly: readOnlyView }}
                    onChange={(e) => setSatLockEveningCheck(e.target.checked)}
                    control={
                      <Checkbox
                        checked={satLockEveningCheck}
                        disabled={readOnlyView}
                      />
                    }
                    label="Lock Evening"
                  />
                </FormControl>
              </Grid>

              <Grid key={0} item xs={8} marginTop={3}></Grid>
              <Grid key={4} item xs={2}>
                {!readOnlyView && (
                  <Button
                    onClick={cancelEditing}
                    color="secondary"
                    size="large"
                    style={{
                      minWidth: "100%",
                      minHeight: "120%",
                    }}
                  >
                    Cancel
                  </Button>
                )}
              </Grid>
              <Grid key={5} item xs={2}>
                {readOnlyView && (
                  <Button
                    sx={{ minWidth: "100%" }}
                    color="primary"
                    size="large"
                    onClick={makeEditable}
                    disabled={moment(effectiveDate).isBefore()}
                  >
                    Edit
                  </Button>
                ) }
                {!readOnlyView && (
                  <Button
                    color="primary"
                    size="large"
                    style={{
                      minWidth: "100%",
                      minHeight: "120%",
                    }}
                    onClick={saveData}
                  >
                    Save
                  </Button>
                )}
              </Grid>

              <Grid key={0} item xs={12} marginTop={3}></Grid>
            </Grid>
          </div>
        </div>

        <SnackBar
          open={open}
          message={message}
          severity={severity}
          onClose={handleAlertNotifClose}
        ></SnackBar>
        {openDeleteDialog && (
          <DeleteRuleDialog
            onCloseDialog={onCloseDialog}
            onDeleteCallback={onDeleteCallback}
            arAId={eventRAId}
            effectiveDate={moment(effectiveDate).format('MMM DD, YYYY')}
            ruleId={ruleId}

          />
        )}
        {showWSDialog &&  <WorkSchedulesDialog onCloseDialog={() => setShowWSDialog(false)} data = {ruleId} />}

      </div>
    </div>
  );
};
export default AddEditRule;
